import * as z from "zod";

export const reassignAndMoveFulfillmentGroup = {
  name: "reassignAndMoveFulfillmentGroup" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    fulfillmentServiceId: z.string(),
    externalLocationId: z.string(),
  }),
  output: z.object({ successCount: z.number(), totalCount: z.number() }),
};
